import CollectionManager from "../utils/collection-manager";

export default {
    template: document.querySelector('[data-collection-creation-form-template]') ?
            document.querySelector('[data-collection-creation-form-template]').innerHTML:
            null,
    props: {
        hideBack: {
            type: Boolean
        },
        publicationType: {
            type: [Number,String],
            required: true
        }
    },
    inject: {
        updatePopper: {
            default: () => {},
        },
    },
    data() {
        return {
            collectionTitle: null,
            showError: false,
        }
    },
    methods: {
        /**
         * Add new collection
         * @return {Promise<void>}
         */
        async addNewCollection() {
            this.showError = ! this.collectionTitle;

            if ( ! this.collectionTitle) {
                return;
            }

            this.$emit('loading', true);
            const newCollection = await CollectionManager.addNewCollection(this.collectionTitle, this.publicationType);

            // Reset the title variable
            this.collectionTitle = null;
            this.$emit('loading', false);
            this.$emit('collection-added', newCollection);
            this.close();
        },
        /**
         * Close the form
         */
        close() {
            this.$emit('close');
        }
    },
    mounted() {
        this.updatePopper();
    },
    updated() {
        this.updatePopper();
    }
}